import { ReactNode } from 'react';
import { RachelChatContext } from '../../contexts/Rachel.context';
import { RachelAttachmentsContext } from '../../contexts/RachelAttachments.context';
import { RachelRegionsContext } from '../../contexts/RachelRegions.context';
import { useDocumentDropGuard } from '../../hooks/useDocumentDropGuard';
import { useIsRachelAvailable } from '../../hooks/useIsRachelAvailable';
import { useRachelAttachmentsValue } from '../../hooks/useRachelAttachmentsValue';
import { useRachelChat } from '../../hooks/useRachelChat';
import { useRachelRegions } from '../../hooks/useRachelRegions';

interface RachelChatProviderProps {
  children: ReactNode;
}

const RachelChatProviderInner = ({ children }: RachelChatProviderProps) => {
  const chat = useRachelChat();
  const regions = useRachelRegions();
  const attachments = useRachelAttachmentsValue();
  useDocumentDropGuard();

  return (
    <RachelChatContext.Provider value={chat}>
      <RachelRegionsContext.Provider value={regions}>
        <RachelAttachmentsContext.Provider value={attachments}>
          {children}
        </RachelAttachmentsContext.Provider>
      </RachelRegionsContext.Provider>
    </RachelChatContext.Provider>
  );
};

const RachelChatProvider = ({ children }: RachelChatProviderProps) => {
  const isAvailable = useIsRachelAvailable();

  if (!isAvailable) {
    return <>{children}</>;
  }

  return <RachelChatProviderInner>{children}</RachelChatProviderInner>;
};

export default RachelChatProvider;
